import React from 'react';
import { Icon } from '#app/components/ui/icon.tsx';
import { type SchemaElement } from '#app/models/sync-line-chart/types.ts';
import { cn } from '#app/utils/misc.tsx';

export function LineChartLegend({
  marks,
  patternColor,
}: {
  marks: SchemaElement['marks'];
  patternColor: string;
}) {
  return (
    <ul className="flex items-center justify-between gap-x-5">
      {marks
        .filter((mark) => mark.hideLegend !== true)
        .map((mark) => (
          <MarkLegend
            key={mark.title}
            mark={mark}
            patternColor={patternColor}
          />
        ))}
    </ul>
  );
}

export function MarkLegend({
  mark,
  tooltip,
  patternColor = '#9292a6',
}: {
  tooltip?: boolean;
  mark: SchemaElement['marks'][0];
  patternColor?: string;
}) {
  switch (mark.dashStyle) {
    case 'dotted':
      return (
        <li key={mark.title} className="flex items-center">
          <div className="relative mr-2 flex max-h-[6px] gap-x-1">
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
          </div>
          <span className="text-body">{mark.title}</span>
        </li>
      );
    case 'dotted2':
      return (
        <li key={mark.title} className="flex items-center">
          <div className="relative mr-2 flex max-h-[6px] gap-x-1">
            <span
              className="absolute top-1/2 block h-[3px]  w-[26px] -translate-y-1/2"
              style={{ backgroundColor: mark.stroke }}
            />
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
            <span
              className="block h-[6px] w-[6px] rounded-full"
              style={{ backgroundColor: mark.stroke }}
            />
          </div>
          <span className="text-body">{mark.title}</span>
        </li>
      );
    case 'pattern':
      return (
        <li
          key={mark.title}
          className={cn('flex items-center', {
            relative: tooltip,
          })}
        >
          <svg className="mr-2 block h-6 w-6">
            <defs>
              <pattern
                id="diagonalHatch"
                patternUnits="userSpaceOnUse"
                width="4"
                height="4"
              >
                <path
                  d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
                  strokeWidth={1}
                  stroke={patternColor}
                />
              </pattern>
            </defs>
            <rect fill="url(#diagonalHatch)" width="24" height="24" />
          </svg>
          <span
            className={cn('inline-flex text-body', {
              'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2':
                tooltip,
            })}
          >
            <Icon name="exclamation-triangle" className="mr-2" size="font" />
            {!tooltip && mark.title}
          </span>
        </li>
      );
  }
}
